export var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/compatible/es/_util/types.js
// module id = 1251
// module chunks = 1